export const DRAG_ITEM_FOCUS_CONTAINER_SUFFIX = '-focus-container'
export const DRAG_ITEM_PREFIX = 'drag-item-'
export const MOUSE_ENTER_EVENT = 'mouseenter'
